import { Component, inject } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { UpdateDistributorComponent } from '../update-distributor/update-distributor.component';
import { ListDistributorPartnersComponent } from '../list-distributor-partners/list-distributor-partners.component';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDTO } from '../../../models/UserDTO.model';
import { DistributorsService } from '../../../services/distributors.service';
import { ListDistributorCustomerComponent } from '../list-distributor-customer/list-distributor-customer.component';
import { ListDistributorStaffComponent } from '../distributor-staff/list-distributor-staff/list-distributor-staff.component';

@Component({
    selector: 'app-distributor-account',
    templateUrl: './distributor-account.component.html',
    styleUrls: ['./distributor-account.component.scss'],
    imports: [
        CommonModule,
        UpdateDistributorComponent,
        ListDistributorPartnersComponent,
        ListDistributorCustomerComponent,
        ListDistributorStaffComponent
    ]
})
export class DistributorAccountComponent {

    private route = inject(ActivatedRoute);
    private router = inject(Router);
    public location = inject(Location);
    public distributorsService = inject(DistributorsService);

    public distributorId?: number;
    public distributorData?: UserDTO | any;
    
    ngOnInit() {
        this.distributorId = +(this.route.snapshot.paramMap.get('id') || this.route.snapshot.queryParamMap.get('id') || 0);
        this.currentTab = this.route.snapshot.queryParamMap.get('tab') || this.currentTab;
        this.distributorData = history.state.distributorData;
        if (this.distributorData?.userId != this.distributorId) {
            if (this.distributorId > 0) {
                // то, что передано в качестве параметра id - используем за исходные данные
                this.distributorsService.getByIdAsync(this.distributorId).then(r => this.distributorData = r);
            } else if (this.distributorData?.userId) {
                // установим userId? который находится в this.distributorData в качестве параметра id
                this.distributorId = this.distributorData?.userId || 0;
                if (this.distributorId) {
                    this.updateUrl();
                }
            }
        }
        this.setupTabEventListeners();
    }


    //#region - Tabs -

    public currentTab: string = 'partners';

    private setupTabEventListeners(): void {
        const tabElements = document.querySelectorAll('button[data-bs-toggle="tab"]');
        tabElements.forEach(tabElement => {
            tabElement.addEventListener('shown.bs.tab', (event: Event) => {
                const target = event.target as HTMLElement;
                const tabId = target.getAttribute('data-bs-target');
                this.onTabActivated(tabId);
            });
        });
        this.onTabActivated(this.currentTab || 'partners');
    }

    private updateUrl() {
        const url = this.router.createUrlTree([], {
            queryParams: {
                tab: this.currentTab === 'partners' ? undefined : this.currentTab,
                id: +this.route.snapshot.paramMap.get('id')! === this.distributorId ? undefined : this.distributorId
            },
            queryParamsHandling: 'merge'
        }).toString();
        this.location.replaceState(url);
    }

    private onTabActivated(tabId: string | null): void {
        tabId = tabId || '';
        if (tabId?.startsWith('#') === true) tabId = tabId.substring(1);
        if (tabId?.endsWith('-tab') === true) tabId = tabId.substring(0, tabId.length - 4);
        this.currentTab = tabId;

        this.updateUrl();

        switch (tabId) {
            case 'partners':
                // Логика для таба Partners
                //this.loadSims();
                break;
            case 'customers':
                // Логика для таба Customers
                break;
            case 'staff':
                // Логика для таба Staff
                break;
        }
    }

    //#endregion - Tabs -

}
